import { render, staticRenderFns } from "./exemptEMBA.vue?vue&type=template&id=5929ca92"
import script from "./exemptEMBA.vue?vue&type=script&lang=js"
export * from "./exemptEMBA.vue?vue&type=script&lang=js"
import style0 from "./exemptEMBA.vue?vue&type=style&index=0&id=5929ca92&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports